import React, { forwardRef, ReactNode, Ref } from 'react';
import classNames from 'classnames';

import styles from './Page.module.css';

interface Props {
  children: ReactNode;
  className?: string;
  header?: ReactNode;
  footer?: ReactNode;
  dataHcName?: string;
}

export const ROLE_DOCUMENT = 'document';

export const Page = forwardRef(
  (
    { children, className, header, footer, dataHcName }: Props,
    ref: Ref<HTMLDivElement>,
  ) => {
    return (
      <div
        role={ROLE_DOCUMENT}
        data-hc-name={dataHcName}
        className={classNames(styles.Page, className, {
          [styles.hasHeader]: !!header,
          [styles.hasFooter]: !!footer,
        })}
      >
        {header}
        <div className={styles.Content} ref={ref}>
          {children}
        </div>
        {footer}
      </div>
    );
  },
);
